<template>
  <div v-if="editor">
    <editor-content :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
// eslint-disable-next-line import/no-extraneous-dependencies
import Document from '@tiptap/extension-document';
// eslint-disable-next-line import/no-extraneous-dependencies
import Paragraph from '@tiptap/extension-paragraph';
// eslint-disable-next-line import/no-extraneous-dependencies
import Text from '@tiptap/extension-text';
import Mention from '@tiptap/extension-mention';
import Link from '@tiptap/extension-link';

const TwChatContentMention = Mention.extend({
  name: 'chatContentMention',
  addOptions() {
    return {
      users: []
    };
  },
  renderHTML({ node }) {
    const user = _.find(this.options.users || [], { name: node.attrs.label });
    return [
      'span',
      {
        'data-mention': '',
        class: 'mention',
        'data-id': user?.id,
        'data-label': node.attrs.label
      },
      `@${node.attrs.label}`
    ];
  },
  parseHTML() {
    return [
      {
        tag: 'span[data-mention]',
        getAttrs: dom => ({
          id: dom.getAttribute('data-id'),
          label: dom.getAttribute('data-label')
        })
      }
    ];
  }
});

export default {
  name: 'TwChatContent',
  props: {
    content: String,
    users: {
      type: Array,
      default: () => []
    }
  },
  components: {
    EditorContent,
  },
  data() {
    return {
      editor: null
    };
  },
  watch: {
    users: {
      handler(newUsers) {
        if (this.editor) {
          this.editor.destroy();
        }
        this.editor = new Editor({
          extensions: [
            Document,
            Paragraph,
            Text,
            Link,
            TwChatContentMention.configure({
              users: newUsers || []
            })
          ],
          editable: false,
          content: this.content
        });
      },
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  }
};
</script>
